import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomePage } from './pages/home-page/home-page.component';
import { SobrePage } from './pages/sobre-page/sobre-page.component';
import { ApiService } from './services/api.service';
import { AppService } from './services/app.service';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; //@3.4.2
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatModalInfoDialogComponent } from './components/modais/mat-modal-info-dialog/mat-modal-info-dialog.component';
import { ModalConfirmComponent } from './components/modais/modal-confirm/modal-confirm.component'; 
import { IntegerDirective } from './directives/integer.directive';
import { PhoneMaskDirective } from './directives/phone-mask.directive';
import { UppercaseDirective } from './directives/uppercase.directive';
import { ModulosResolver } from './resolvers/modulos.resolver';
import { ModuloService } from './services/modulo.service';  
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { ModuloLogo } from './modulos/logo/logo.component';
import { Modulo } from './modulos/modulo/modulo.component';
import { DataService } from './services/data.service';
import { GaleriaLightComponent } from './components/galeria/galeria-light/galeria-light.component';
import { BreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.component';
import { GtagService } from './services/gtag.service';
import { HeaderComponent } from './components/partial/header/header.component';
import { FooterComponent } from './components/partial/footer/footer.component';
import { WhatsappComponent } from './modulos/whatsapp/whatsapp.component';
import { BoxFormPesquisaComponent } from './components/box-form-pesquisa/box-form-pesquisa.component';
import { RedeSocialComponent } from './modulos/rede-social/rede-social.component';
import { EnderecoComponent } from './modulos/endereco/endereco.component';
import { UnidadesComponent } from './modulos/unidades/unidades.component';
import { BtnListaDesejoComponent } from './components/btns/btn-lista-desejo/btn-lista-desejo.component';
import { BtnUsuarioLoginComponent } from './components/btns/btn-usuario-login/btn-usuario-login.component';
import { BtnCartComponent } from './components/btns/btn-cart/btn-cart.component';
import { CarrinhoPage } from './pages/cart-page/cart-page.component';
import { PageErrorComponent } from './components/error/page-error/page-error.component';
import { LoaderComponent } from './components/loader/loader/loader.component';
import { MenuComponent } from './components/partial/menu/menu.component';
import { BannerSliderSlickComponent } from './modulos/banner-slider-slick/banner-slider-slick.component';
import { MenuFooterComponent } from './components/partial/menu-footer/menu-footer.component';
import { NewsletterComponent } from './modulos/newsletter/newsletter.component';
import { ContatoComponent } from './modulos/contato/contato.component';
import { ProdutoCategoriaDestaqueComponent } from './modulos/produto-categoria-destaque/produto-categoria-destaque.component';
import { ProdutoItemComponent } from './components/produto/produto-item/produto-item.component';
import { ProdutoItemValorComponent } from './components/produto/produto-item-valor/produto-item-valor.component';
import { ProdutoPromocaoPercentualComponent } from './components/produto/produto-promocao-percentual/produto-promocao-percentual.component';
import { FaleConoscoComponent } from './modulos/fale-conosco/fale-conosco.component';
import { LinksExternosComponent } from './components/partial/links-externos/links-externos.component';
import { ProdutoNovidadeComponent } from './modulos/produto-novidade/produto-novidade.component';
import { DicasComponent } from './modulos/dicas/dicas.component';
import { DicaItemComponent } from './components/dica/dica-item/dica-item.component';
import { BannerDestaqueComponent } from './modulos/banner-destaque/banner-destaque.component';
import { LinkDestaquesComponent } from './modulos/link-destaques/link-destaques.component';
import { FormatDuracaoPipe } from './pipes/format-duracao.pipe';
import { FormatNumberPipe } from './pipes/format-number.pipe';
import { ServicoPage } from './pages/servico/servico-page/servico-page.component';
import { ServicosPage } from './pages/servico/servicos-page/servicos-page.component';
import { CidadesPage } from './pages/a-serra-gaucha/cidades-page/cidades-page.component'; 
import { CidadeItemComponent } from './components/cidade/cidade-item/cidade-item.component';
import { CidadePage } from './pages/a-serra-gaucha/cidade-page/cidade-page.component';
import { ProdutoGaleriaComponent } from './components/produto/produto-galeria/produto-galeria.component';
import { ProdutoVideoModal } from './components/produto/produto-video-modal/produto-video-modal.component';
import { ProdutoGaleriaModal } from './components/produto/produto-galeria-modal/produto-galeria-modal.component';
import { DmCartAdd } from './components/carrinho/dm-cart-add/dm-cart-add.component';
import { FormatValorManagerPipe } from './pipes/format-valor-manager.pipe';
import { ComboManagerHotelComponent } from './components/combos/combo-manager-hotel/combo-manager-hotel.component';
import { ServicoService } from './services/servico.service';
import { StorageService } from './services/storage.service';
import { ValidatorService } from './services/validator.service';
import { CartService } from './services/cart.service';
import { DmCartResumoStepsComponent } from './components/carrinho/dm-cart-resumo-steps/dm-cart-resumo-steps.component';
import { GetTarifaMinimaListaPipe } from './pipes/get-tarifa-minima-lista.pipe';
import { MatSelectSearchComponent } from './components/combos/mat-select-search/mat-select-search.component';
import { MatOptionModule } from '@angular/material/core';
import { DmCartPassageirosQtdComponent } from './components/carrinho/dm-cart-passageiros-qtd/dm-cart-passageiros-qtd.component';
import { DmCartPassageiroTitularComponent } from './components/carrinho/dm-cart-passageiro-titular/dm-cart-passageiro-titular.component';
import { DmCartTarifasResumoComponent } from './components/carrinho/dm-cart-tarifas-resumo/dm-cart-tarifas-resumo.component';
import { DmCartDataServicoComponent } from './components/carrinho/dm-cart-data-servico/dm-cart-data-servico.component';
import { DmCartItemComponent } from './components/carrinho/dm-cart-item/dm-cart-item.component';
import { TipoServicoPipe } from './pipes/tipo-servico.pipe';
import { FormatDateTextPipe } from './pipes/format-date-text.pipe';
import { DateService } from './services/date.service';
import { DmCartItemEliminarModal } from './components/carrinho/dm-cart-item-eliminar-modal/dm-cart-item-eliminar-modal.component';
import { DmCartItemDetalheModal } from './components/carrinho/dm-cart-item-detalhe-modal/dm-cart-item-detalhe-modal.component';
import { DmCartResumoComponent } from './components/carrinho/dm-cart-resumo/dm-cart-resumo.component';
import { PagamentoPage } from './pages/pagamento-page/pagamento-page.component';
import localePt from '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';
import { UsuarioLoginModal } from './components/usuario/usuario-login-modal/usuario-login-modal.component';
import { BtnFacebookLoginComponent } from './components/btns/btn-facebook-login/btn-facebook-login.component';
import { BtnGoogleLoginComponent } from './components/btns/btn-google-login/btn-google-login.component';
import { PagamentoComponent } from './modulos/pagamento/pagamento.component';
import { MaskDirective } from './directives/mask.directive';
import { PagamentoCartaoCieloComponent } from './components/pagamento/pagamento-cartao-cielo/pagamento-cartao-cielo.component';
import { PagamentoCartaoRedePayComponent } from './components/pagamento/pagamento-cartao-rede-pay/pagamento-cartao-rede-pay.component';
import { ComboParcelasCartaoComponent } from './components/combos/combo-parcelas-cartao/combo-parcelas-cartao.component';
import { PagamentoDadosPassageirosComponent } from './components/pagamento/pagamento-dados-passageiros/pagamento-dados-passageiros.component';
import { TipoPassageiroDescPipe } from './pipes/tipo-passageiro-desc.pipe';
import { TrabalheConoscoPage } from './pages/trabalhe-conosco-page/trabalhe-conosco-page.component';
import { FotosPage } from './pages/fotos-page/fotos-page.component';
import { UsuarioService } from './services/usuario.service';
import { UsuarioLogadoModal } from './components/usuario/usuario-logado-modal/usuario-logado-modal.component';
import { PagamentoFileReprovadoModal } from './components/pagamento/pagamento-file-reprovado-modal/pagamento-file-reprovado-modal.component';
import { PagamentoReprovadoModal } from './components/pagamento/pagamento-reprovado-modal/pagamento-reprovado-modal.component';
import { PagamentoAprovadoModal } from './components/pagamento/pagamento-aprovado-modal/pagamento-aprovado-modal.component';
import { PagamentoAprovadoBoxComponent } from './components/pagamento/pagamento-aprovado-box/pagamento-aprovado-box.component';
import { DmCartPagamentoConfirmacaoEmailComponent } from './components/carrinho/pagamento/dm-cart-pagamento-confirmacao-email/dm-cart-pagamento-confirmacao-email.component';
import { DmCartPagamentoConfirmacaoDownloadComponent } from './components/carrinho/pagamento/dm-cart-pagamento-confirmacao-download/dm-cart-pagamento-confirmacao-download.component';
import { MinhasViagensPage } from './pages/minhas-viagens-page/minhas-viagens-page.component';
import { ProdutoItemTwoComponent } from './components/produto/produto-item-two/produto-item-two.component';
import { DateFormatTextPipe } from './pipes/date-format-text.pipe';
import { UsuarioPerfilComponent } from './components/usuario/usuario-perfil/usuario-perfil.component';  
import { DmCartDadosVooComponent } from './components/carrinho/dm-cart-dados-voo/dm-cart-dados-voo.component';
import { ComboAeroportoComponent } from './components/combos/combo-aeroporto/combo-aeroporto.component';
import { ComboCiaAereaComponent } from './components/combos/combo-cia-aerea/combo-cia-aerea.component';
import { ListaDesejosPage } from './pages/lista-desejos-page/lista-desejos-page.component';
import { BtnListarDesejoComponent } from './components/btns/btn-listar-desejo/btn-listar-desejo.component';
import { PoliticaDeCancelamentoPage } from './pages/politica-de-cancelamento-page/politica-de-cancelamento-page.component';
import { PagafacilPage } from './pages/pagafacil-page/pagafacil-page.component';
import { DmCartPagamentoFormasPagamentoComponent } from './components/carrinho/dm-cart-pagamento-formas-pagamento/dm-cart-pagamento-formas-pagamento.component';
import { DmCartPagamentoTipoComponent } from './components/carrinho/pagamento/tipo/dm-cart-pagamento-tipo/dm-cart-pagamento-tipo.component';
import { DmCartPagamentoCieloComponent } from './components/carrinho/pagamento/tipo/dm-cart-pagamento-cielo/dm-cart-pagamento-cielo.component';
import { DmCartPagamentoRedePayComponent } from './components/carrinho/pagamento/tipo/dm-cart-pagamento-rede-pay/dm-cart-pagamento-rede-pay.component';
import { DmCartPagamentoReprovadoModal } from './components/carrinho/modal/dm-cart-pagamento-reprovado/dm-cart-pagamento-reprovado.component';
import { DmCartReservaReprovadoModal } from './components/carrinho/modal/dm-cart-reserva-reprovado/dm-cart-reserva-reprovado.component';
import { MaxPipe } from './pipes/max.pipe';
import { BannerLinksComponent } from './modulos/banner-links/banner-links.component';
import { PoliticaDeSegurancaPage } from './pages/politica-de-seguranca-page/politica-de-seguranca-page.component';
import { PoliticaDePrivacidadePage } from './pages/politica-de-privacidade-page/politica-de-privacidade-page.component';
import { ProdutoVendaOfflineComponent } from './components/produto/produto-venda-offline/produto-venda-offline.component';
import { ContatoPageComponent } from './pages/contato-page/contato-page.component';
import { MeusServicosPage } from './pages/meus-servicos-page/meus-servicos-page.component';
import { ComboHorariosComponent } from './components/combos/combo-horarios/combo-horarios.component';
import { PassageirosModal } from './components/minhas-viagens/passageiros-modal/passageiros-modal.component';

import { FacebookLoginProvider, GoogleLoginProvider, SocialAuthServiceConfig, SocialLoginModule } from "angularx-social-login";
import { UsuarioMeusDadosModal } from './components/usuario/usuario-meus-dados-modal/usuario-meus-dados-modal.component';
import { DestaquesComponent } from './components/partial/destaques/destaques.component';
import { ProdutoDestaquesComponent } from './modulos/produto-destaques/produto-destaques.component';
import { ProdutoPromocaoComponent } from './modulos/produto-promocao/produto-promocao.component';
import { ProdutoByCategoriaComponent } from './modulos/produto-by-categoria/produto-by-categoria.component';
import { ProdutoItemThreeComponent } from './components/produto/produto-item-three/produto-item-three.component';
import { ProdutoSlideShowComponent } from './components/produto/produto-slide-show/produto-slide-show.component';
import { ProdutoItemFourComponent } from './components/produto/produto-item-four/produto-item-four.component';
import { PerguntasFrequentesPageComponent } from './pages/componente/faq/perguntas-frequentes-page/perguntas-frequentes-page.component';
import { PagamentoConfirmacaoPage } from './pages/pagamento-confirmacao-page/pagamento-confirmacao-page.component';
import { ChamadaComponent } from './modulos/chamada/chamada.component';
import { UsuarioEmailCadastroComponent } from './components/usuario/usuario-email-cadastro/usuario-email-cadastro.component';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { HorariosComponent } from './modulos/horarios/horarios.component';
import { PageManutencaoComponent } from './components/page/page-manutencao/page-manutencao.component';


registerLocaleData(localePt,'pt-BR');   
 
const chaveFacebook = "3306876762669613";   
const chaveGoogle   = "748920387297-8v5dtd22dmerbhfmkoa73seehqsuqaha.apps.googleusercontent.com";  

@NgModule({
    declarations: [
        AppComponent,
        HomePage,
        SobrePage,
        MatModalInfoDialogComponent,
        ModalConfirmComponent,
        IntegerDirective,
        PhoneMaskDirective,
        UppercaseDirective,
        SafeHtmlPipe,
        ModuloLogo,
        Modulo,
        GaleriaLightComponent,
        BreadcrumbsComponent,
        HeaderComponent,
        FooterComponent,
        WhatsappComponent,
        BoxFormPesquisaComponent,
        RedeSocialComponent,
        EnderecoComponent,
        UnidadesComponent,
        BtnListaDesejoComponent,
        BtnUsuarioLoginComponent,
        BtnCartComponent,
        CarrinhoPage,
        PageErrorComponent,
        LoaderComponent,
        MenuComponent,
        BannerSliderSlickComponent,
        MenuFooterComponent,
        NewsletterComponent,
        ContatoComponent,
        ProdutoCategoriaDestaqueComponent,
        ProdutoItemComponent,
        ProdutoItemValorComponent,
        ProdutoPromocaoPercentualComponent,
        FaleConoscoComponent,
        LinksExternosComponent,
        ProdutoNovidadeComponent,
        DicasComponent,
        DicaItemComponent,
        BannerDestaqueComponent,
        LinkDestaquesComponent,
        FormatDuracaoPipe,
        SafeHtmlPipe,
        ServicoPage,
        ServicosPage,
        CidadesPage,
        CidadeItemComponent,
        CidadePage,
        ProdutoGaleriaComponent,
        ProdutoVideoModal,
        ProdutoGaleriaModal,
        DmCartAdd,
        FormatValorManagerPipe,
        ComboManagerHotelComponent,
        DmCartResumoStepsComponent,
        GetTarifaMinimaListaPipe,
        MatSelectSearchComponent,
        DmCartPassageirosQtdComponent,
        DmCartPassageiroTitularComponent,
        DmCartTarifasResumoComponent,
        DmCartDataServicoComponent,
        DmCartItemComponent,
        TipoServicoPipe,
        FormatDateTextPipe,
        DmCartItemEliminarModal,
        DmCartItemDetalheModal,
        DmCartResumoComponent,
        PagamentoPage,
        UsuarioLoginModal,
        BtnFacebookLoginComponent,
        BtnGoogleLoginComponent,
        PagamentoComponent,
        MaskDirective,
        PagamentoCartaoCieloComponent,
        PagamentoCartaoRedePayComponent,
        ComboParcelasCartaoComponent,
        PagamentoDadosPassageirosComponent,
        TipoPassageiroDescPipe,
        TrabalheConoscoPage,
        FotosPage,
        UsuarioLogadoModal,
        PagamentoFileReprovadoModal,
        PagamentoReprovadoModal,
        PagamentoAprovadoModal,
        PagamentoAprovadoBoxComponent,
        DmCartPagamentoConfirmacaoEmailComponent,
        DmCartPagamentoConfirmacaoDownloadComponent,
        MinhasViagensPage,
        ProdutoItemTwoComponent,
        DateFormatTextPipe,
        UsuarioPerfilComponent,
        DmCartDadosVooComponent,
        ComboAeroportoComponent,
        ComboCiaAereaComponent,
        ListaDesejosPage,
        BtnListarDesejoComponent,
        PoliticaDeCancelamentoPage,
        PagafacilPage,
        DmCartPagamentoFormasPagamentoComponent,
        DmCartPagamentoTipoComponent,
        DmCartPagamentoCieloComponent,
        DmCartPagamentoRedePayComponent,
        DmCartPagamentoReprovadoModal,
        DmCartReservaReprovadoModal,
        DmCartPagamentoFormasPagamentoComponent,
        MaxPipe,
        BannerLinksComponent,
        PoliticaDeSegurancaPage,
        PoliticaDePrivacidadePage,
        ProdutoVendaOfflineComponent,
        ContatoPageComponent,
        MeusServicosPage,
        ComboHorariosComponent,
        PassageirosModal,
        UsuarioMeusDadosModal,
        DestaquesComponent,
        ProdutoDestaquesComponent,
        ProdutoPromocaoComponent,
        ProdutoByCategoriaComponent,
        ProdutoItemThreeComponent,
        ProdutoSlideShowComponent,
        ProdutoItemFourComponent,
        PerguntasFrequentesPageComponent,
        PagamentoConfirmacaoPage,
        ChamadaComponent,
        UsuarioEmailCadastroComponent,
        HorariosComponent,
        PageManutencaoComponent
    ],
    exports: [
        BoxFormPesquisaComponent,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        FormsModule,
        LazyLoadImageModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        MatIconModule,
        MatDialogModule,
        MatSelectModule,
        MatRadioModule,
        MatOptionModule,
        //DeviceDetectorModule.forRoot(),
        SocialLoginModule,
        RecaptchaV3Module
    ],
    providers: [
        ApiService,
        AppService,
        DataService,
        ModuloService,
        ModulosResolver,
        GtagService,
        ServicoService,
        StorageService,
        ValidatorService,
        CartService,
        DateService,
        UsuarioService,
        { provide: RECAPTCHA_V3_SITE_KEY, useValue: '6Ld-Me0ZAAAAAEmwWeSeE6QypNRZmk7d3_zu3IFS' },
        { provide: LOCALE_ID, useValue: 'pt-BR' },
        {
            provide: 'SocialAuthServiceConfig',
            useValue: {
                autoLogin: false,
                providers: [
                    {
                        id: GoogleLoginProvider.PROVIDER_ID,
                        provider: new GoogleLoginProvider(chaveGoogle)
                    }, {
                        id: FacebookLoginProvider.PROVIDER_ID,
                        provider: new FacebookLoginProvider(chaveFacebook)
                    }
                ]
            } as SocialAuthServiceConfig,
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
